
export default {
	props: {
		puzzles: {
			type: Array,
			required: true,
		},
		period: {
			type: String,
			required: true,
		},
	},
	data() {
		return { isOpen: false };
	},
	methods: {
		open() {
			this.isOpen = !this.isOpen;
		},
	},
};
